import React from "react";
import { useParams } from "react-router-dom";
import { ClearanceStatus } from "../../../../../utils/constants";
import "../css/EscortArrivalList.css";
import EscortArrivalActionButtons from "./EscortArrivalActionButtons";
import EscortVehicleList from "./EscortVehicleList";

const EscortArrivalList = ({
  arrivalVehicles,
  officers,
  tripData,
  airportName,
}) => {
  const { flightId } = useParams();
  const arrivalStatus =
    tripData?.escortService?.requiresOnArrival &&
    (tripData?.escortService?.arrivalStatus ===
      ClearanceStatus.CLEARANCE_REQUESTED ||
      tripData?.escortService?.arrivalStatus ===
        ClearanceStatus.CLEARANCE_GRANTED ||
      tripData?.escortService?.arrivalStatus === ClearanceStatus.PAID);

  return (
    <div className="arrival-vehicle-overlay">
      <div className="arrival-vehicle-list">
        {airportName} (Arrivals)
        <div className="arrival-vehicle-list-box">
          <EscortVehicleList vehicles={arrivalVehicles} />
          {(arrivalVehicles?.length > 0 || arrivalStatus) && (
            <EscortArrivalActionButtons
              flightPlanId={flightId}
              officers={officers}
              clearanceStatus={tripData.escortService?.arrivalStatus}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EscortArrivalList;
